import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const TAX_RATE_SCHEMA = Object.freeze({
    VALUE: 0,
    IS_DEFAULT: false,
  }),
  RECORD = generateSchema(TAX_RATE_SCHEMA),
  KEYS: any = generateKeys(TAX_RATE_SCHEMA);

export class TaxRate extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get value(): number {
    return this.get(KEYS.VALUE);
  }
}
